import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { StateHelperService } from '../../../services/proprietary/state-helper.service';
import { DocumentViewerObjectService } from './document-viewer-object.service';
import { DocumentViewerObjectState } from './document-viewer-object.state';

@NgModule({
    imports: [NgxsModule.forFeature([DocumentViewerObjectState])],
    declarations: [],
    providers: [DocumentViewerObjectService, StateHelperService],
    exports: []
})
export class DocumentViewerObjectModule { }
